import React, { Suspense } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import Navbar from "components/navigation/Navbar";
import { ProtectedLayout } from "auth0";
import { NotFound } from "./lazyPages";
import { adminRoutes } from "./adminRoutes";
import { privateRoutes } from "./privateRoutes";
import { publicRoutes } from "./publicRoutes";
import { LoaderOverlayMain } from "../elements/Loader";

export function AppLayout() {
  return (
    <>
      <Navbar />
      <Suspense fallback={<LoaderOverlayMain />}>
        <Outlet />
      </Suspense>
    </>
  );
}

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        {publicRoutes}
        <Route element={<ProtectedLayout />}>
          {privateRoutes}
          {adminRoutes}
        </Route>
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
